import BaseReduction from './BaseReduction';

export default class FactorReduction extends BaseReduction {}
